module.exports = __webpack_public_path__ + "media/images/article/2021_02-7bbcdc9f2c6021aa7e349b2bfaa060b2.png";